import Vue from 'vue'

Vue.filter('removeCountry', (value) => {
    if (!value) return null
    return value.replace(
        /Budapest,|Hungary|Magyarország,|London|UK|United Kingdom,/gi,
        ''
    )
})
